import { render } from "./SelectCheckbox.vue?vue&type=template&id=c68a6f82"
import script from "./SelectCheckbox.vue?vue&type=script&lang=js"
export * from "./SelectCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script